export const IconContract = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				d="M14,0 C16.209139,0 18,1.790861 18,4 L18,16 C18,18.209139 16.209139,20 14,20 L6,20 C3.790861,20 2,18.209139 2,16 L2,4 C2,1.790861 3.790861,0 6,0 L14,0 Z M14,2 L6,2 C4.8954305,2 4,2.8954305 4,4 L4,16 C4,17.1045695 4.8954305,18 6,18 L14,18 C15.1045695,18 16,17.1045695 16,16 L16,4 C16,2.8954305 15.1045695,2 14,2 Z M13.2752815,6.31095496 L14.7247185,7.68904504 L9.49544996,13.189045 L8.77073145,13.9512839 L8.04601293,13.189045 L5.27528148,10.2748664 L6.72471852,8.89677627 L8.77,11.048 L13.2752815,6.31095496 Z"
			/>
		</svg>
	);
};
